import { useNotifyClient } from '@juvare/platform-sdk-react/ui/hooks';
import React, { useCallback } from 'react';
import { useAlertConfig, useUserState } from '../../../hooks';
import { InboxClient } from '../clients';
import InboxConfigContext from '../providers/InboxConfigProvider';
export function useInboxClient() {
    const ctx = React.useContext(InboxConfigContext);
    const alertConfig = useAlertConfig();
    const userState = useUserState();
    const notifyClient = useNotifyClient();
    const onInboxTokenRequest = useCallback(() => notifyClient.getInboxToken().then((response) => response.token), [notifyClient]);
    let loginEmail;
    if (alertConfig.loginEmail) {
        loginEmail = alertConfig.loginEmail(userState);
    }
    else if (ctx.loginEmail) {
        loginEmail = ctx.loginEmail;
    }
    else {
        loginEmail = userState.email;
    }
    return React.useMemo(() => new InboxClient(loginEmail, onInboxTokenRequest), [onInboxTokenRequest, loginEmail]);
}
